import * as requests from '../api-request'

export const createChat = async (data = {}, token) => {
  return requests.toJSON('POST', 'co-pilot/create_chat', data, token)
}

export const getHistory = async (data = {}) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `co-pilot?${queryString}`, data)
}

export const getChat = async (data = {}, token) => {
  return requests.toJSON('POST', 'co-pilot/get_chat', data, token)
}

export const submitMessage = async (data = {}) => {
  return requests.toJSON('POST', 'co-pilot/message', data)
}

export const deleteChat = async (chatId) => {
  return requests.toJSON('DELETE', `co-pilot/chat/${chatId}`)
}
